import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';

const ItemReturnMethodError = () => {
  return (
    <div className="sui-mb-4" data-testid="item-return-method-error">
      <Alert status="error" size="small">
        <Typography variant="body-base">
          Please select a return method for this item.
        </Typography>
      </Alert>
    </div>
  );
};

export default ItemReturnMethodError;
